import { atom } from "recoil";

export const firstNameState = atom({ key: "firstNameState", default: { value: null, validationCode: -1 } });
export const lastNameState = atom({ key: "lastNameState", default: { value: null, validationCode: -1 } });
export const birthdateState = atom({ key: "birthdateState", default: { value: null, validationCode: -1 } });
export const emailState = atom({ key: "emailState", default: { value: null, validationCode: -1 } });

export const quotesState = atom({ key: "quotesState", default: [] });
export const pageLevelErrorState = atom({ key: "pageLevelErrorState", default: -1 });

export const submitAttemptCountState = atom({ key: "submitAttemptCountState", default: 0 });
export const waitingForResponseState = atom({ key: "waitingForResponseState", default: null });

export const successfulMatchState = atom({ key: "succesfulMatchState", default: false});

export const staticAppConfig = atom({
  key: "staticAppConfig",
  default: {
    debugMode: window.location.href.indexOf("debug=true") > -1,
    routes: {
      landing: `${process.env.PUBLIC_URL}/`,
      quotesList: `${process.env.PUBLIC_URL}/list`,
      noQuotes: `${process.env.PUBLIC_URL}/quotes-unavailable`,
      shapeError: `${process.env.PUBLIC_URL}/technical-error`,
      auth: `${process.env.PUBLIC_URL}/auth`
    },
  },
});

export const staticAppContent = atom({ key: "staticContent", default: {} });
